import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isSensitiveDataVisible: true,
};

const sensitiveDataSlice = createSlice({
	name: 'sensitiveData',
	initialState,
	reducers: {
		toggleSensitiveData(state) {
			state.isSensitiveDataVisible = !state.isSensitiveDataVisible;
		},
	},
});

export const { toggleSensitiveData } = sensitiveDataSlice.actions;
export const sensitiveDataReducer = sensitiveDataSlice.reducer;
